import { createContext } from 'react';

const typingTestContext = createContext();

export { typingTestContext as default };